// // import modules from './modules';
// import { lazy } from "react";
// //import './App.css'
// const fetch = require('sync-fetch');
// let App, domain, portal_id, prev_url, location, path_split, prefix;

// // domain = window.location.hostname == 'localhost'? 'eum.tespire.co' : window.location.hostname;
// domain = window.location.hostname == 'localhost'? 'uni-staging.tespire.co' : window.location.hostname;
// // const school = useSelector((state) => state.school.value);
// let hostUrl;
// let envArr = ['localhost', 'eum.tespire.co', 'uni-staging.tespire.co'];

// if (envArr.includes(window.location.hostname)) {
// //   hostUrl = 'https://staging-api.jspnigeria.com';
//   hostUrl = 'https://api-staging.tespire.ng';
// } else {
//   hostUrl = 'https://api.tespire.ng';
// }
// // let school = sessionStorage.getItem('school') != undefined ? JSON.parse(sessionStorage.getItem('school')) : fetch('https://api.jspnigeria.com/api/school-info', { headers: { xtenant: domain } }).json();
// let school = fetch(`${hostUrl}/api/school-info`, { headers: { xtenant: domain } }).json();

// const Application = lazy(() => import("./modules/ApplicationPortal"));
// const SecuredPanel = lazy(() => import("./modules/SecuredPanel"));
// // const StaffHostel = lazy(() => import("./modules/StaffHostelPortal"));
// const HostelPortal = lazy(() => import("./modules/HostelPortal"));
// const ResultPortal = lazy(() => import("./modules/ResultPortal"));
// const Students = lazy(() => import("./modules/StudentsPortal"));
// const GenLanding = lazy(() => import("./global-components/landing"));


// let portal_ids = [];



// school?.portals?.map((portal,i) => {
//     portal_ids?.push(portal.portal_id)
// });

// prev_url = document.referrer;

// location = window.location.pathname;

// path_split = location.split("/");
// prefix = path_split[1];


// if (!domain.match(/application|students|securedpanel|hostelportal|resultportal/g) && location == '/' && !prev_url.includes('/auth/login')) {
//     domain = location;
//     sessionStorage.removeItem('portal_id');
// }

// portal_id = sessionStorage.getItem('portal_id') ?? null;

// if (prefix.includes('application') || portal_id == '1') {
//     App = Application;
//     portal_id = '1';
// } else if (prefix.includes('students') || portal_id == '2') {
//     App = Students;
//     portal_id = '2';
// } else if (prefix.includes('securedpanel') || portal_id == '3') {
//     App = SecuredPanel;
//     portal_id = '3';
// } else if (prefix.includes('hostelportal') || portal_id == '4') {
//     App = HostelPortal;
//     portal_id = '4';
// } else if (prefix.includes('resultportal') || portal_id == '5') {
//     App = ResultPortal;
//     portal_id = '5';
// } else if (domain == '/') {   
//     App = GenLanding; 
// }

// if (!(portal_ids?.includes(portal_id) || portal_ids?.includes(parseInt(portal_id)))) {
//     App = GenLanding;
// }




// export default App;



import React, { lazy, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateSchool } from "./modules/SecuredPanel/utils/schoolDetailsStore";
import PageLoad from "./global-components/pageLoad";

const fetchSync = require("sync-fetch");

const Application = lazy(() => import("./modules/ApplicationPortal"));
const SecuredPanel = lazy(() => import("./modules/SecuredPanel"));
const HostelPortal = lazy(() => import("./modules/HostelPortal"));
const ResultPortal = lazy(() => import("./modules/ResultPortal"));
const Students = lazy(() => import("./modules/StudentsPortal"));
const GenLanding = lazy(() => import("./global-components/landing"));
const DomainNotTaken = lazy(() => import("./global-components/DomainNotTaken"));
const ShowInactive = lazy(() => import("./global-components/InactiveComponent"));

const allowedEnvs = ["localhost", "eum.tespire.co", "uni-staging.tespire.co"];

export default function AppContainer() {
    const dispatch = useDispatch();

    const [school, setSchool] = useState(null);
    const [loading, setLoading] = useState(true);

    const hostname = window.location.hostname;
    const domain = hostname === "localhost" ? "uni-staging.tespire.co" : hostname;
    const apiBase = allowedEnvs.includes(hostname) ? "https://api-staging.tespire.ng" : "https://api.tespire.ng";


    useEffect(() => {
        let result;

        try {
            result = fetchSync(`${apiBase}/api/school-info`, {
                headers: { xtenant: domain }
            }).json();
        } catch (err) {
            console.error("School info fetch failed:", err);
            throw err;
        }

        setSchool(result);
        localStorage.setItem("school", JSON.stringify(result));
        dispatch(updateSchool(result));

        const primaryColor = result.primary_color || "#330077";
        localStorage.setItem("jsp-primary", primaryColor);

        document.documentElement.style.setProperty("--jsp-primary", primaryColor);
        document.documentElement.style.setProperty("--jsp-primary-opaque", primaryColor + "c0");
        document.documentElement.style.setProperty("--jsp-primary-hover", primaryColor + "c9");

        setLoading(false);
    }, [apiBase, domain, dispatch]);


    if (loading) return <PageLoad />;

    if (school?.status === false || school?.status === "false") {
        return <DomainNotTaken />;
    }

    if (school?.status === "inactive") {
        return <ShowInactive />;
    }

    const path = window.location.pathname.split("/")[1] || "";
    // let portalId = sessionStorage.getItem("portal_id");
    let portalId;

    const pathToPortal = {
        applicationportal: "1",
        studentsportal: "2",
        securedpanel: "3",
        hostelportal: "4",
        resultportal: "5"
    };

    if (path && !pathToPortal[path]) {
        window.location.replace("/");
        return null;
    }

    if (pathToPortal[path]) {
        portalId = pathToPortal[path];
        sessionStorage.setItem("portal_id", portalId);
    }

    const validPortalIds = school?.portals?.map(p => String(p.portal_id)) || [];

    const portalMap = {
        "1": Application,
        "2": Students,
        "3": SecuredPanel,
        "4": HostelPortal,
        "5": ResultPortal
    };

    let SelectedPortal = GenLanding;

    console.log(portalId);

    // if (portalMap[portalId]) SelectedPortal = portalMap[portalId];
    // if the portal is not valid, redirect to window.location = '/' instead
    // if (!validPortalIds.includes(portalId)) SelectedPortal = GenLanding;


    if (portalMap[portalId]) {
        SelectedPortal = portalMap[portalId];
    }

    if (portalId && !validPortalIds.includes(portalId)) {
        window.location.replace("/");
        return null;
    }



    return <SelectedPortal school={school} />;
}

